import React from "react";

export default function HeroBlock({ data }) {
  return (
    <div
      style={{
        padding: "60px",
        borderRadius: "15px",
        background:
          "linear-gradient(135deg, #6C63FF, #FF6584)",
        textAlign: "center",
        color: "white",
      }}
    >
      <h1 style={{ fontSize: "40px", marginBottom: "10px" }}>
        {data.title || "Hero Title"}
      </h1>
      <p style={{ fontSize: "18px", opacity: 0.8 }}>
        {data.subtitle || "This is a hero subtitle"}
      </p>
    </div>
  );
}
